import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { FileText, Mail } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { useAdminFetch } from '@/hooks/useAdminFetch';

export const Route = createFileRoute('/admin/')({
  component: AdminDashboard,
});

function AdminDashboard() {
  const { fetchAdmin } = useAdminFetch();

  const { data } = useQuery({
    queryKey: ['admin-dashboard-stats'],
    queryFn: async () => {
      const res = await fetchAdmin('/api/admin/dashboard/stats');
      if (!res.ok) throw new Error('Failed to fetch');
      const json = await res.json();
      return json.data;
    },
  });

  const totalPosts = data?.totalPosts ?? 0;
  const totalContacts = data?.totalContacts ?? 0;

  return (
    <div>
      <h1 className="text-2xl font-bold text-white mb-6">Dashboard</h1>
      <div className="grid sm:grid-cols-2 gap-4">
        <Link to="/admin/posts">
          <Card className="border-gray-800 bg-gray-900 hover:border-purple-500/50 transition-colors group cursor-pointer h-full">
            <CardContent className="flex items-center gap-4">
              <div className="p-3 rounded-lg bg-purple-500/20 text-purple-400 group-hover:bg-purple-500/30 transition-colors">
                <FileText className="size-8" />
              </div>
              <div>
                <p className="text-3xl font-bold text-white">{totalPosts}</p>
                <p className="text-gray-400">Tổng bài viết</p>
              </div>
            </CardContent>
          </Card>
        </Link>

        <Link to="/admin/contacts">
          <Card className="border-gray-800 bg-gray-900 hover:border-purple-500/50 transition-colors group cursor-pointer h-full">
            <CardContent className="flex items-center gap-4">
              <div className="p-3 rounded-lg bg-purple-500/20 text-purple-400 group-hover:bg-purple-500/30 transition-colors">
                <Mail className="size-8" />
              </div>
              <div>
                <p className="text-3xl font-bold text-white">{totalContacts}</p>
                <p className="text-gray-400">Tổng contact</p>
              </div>
            </CardContent>
          </Card>
        </Link>
      </div>
    </div>
  );
}
